// export default apps
import shared from "@/shared";
import {environment} from "@/environment/environment";
import authority from "@/../../common/src/assets/authority/authority";
const loadingImg = require("@/../../common/src/assets/image/loading.gif");
import Constant from "../../common/src/assets/constant/constant";

let MicroAppsPort: any = {
    VUE_APP_SUB_RESOURCE: 30031,
    VUE_APP_SUB_USER: 30032,
    VUE_APP_SUB_PLATFORM: 30033,
}

// 子应用域名
let MicroAppsDomain: any = {
    test:{
        VUE_APP_SUB_RESOURCE: 'test-agentresource.eflycloud.com',
        VUE_APP_SUB_USER: 'test-agentuser.eflycloud.com',
        VUE_APP_SUB_PLATFORM: 'test-agentplatform.eflycloud.com',
    },
    preonline:{
        VUE_APP_SUB_RESOURCE: 'pre-agentresource.eflycloud.com',
        VUE_APP_SUB_USER: 'pre-agentuser.eflycloud.com',
        VUE_APP_SUB_PLATFORM: 'pre-agentplatform.eflycloud.com',
    },
    online:{
        VUE_APP_SUB_RESOURCE: 'agentresource.eflycloud.com',
        VUE_APP_SUB_USER: 'agentuser.eflycloud.com',
        VUE_APP_SUB_PLATFORM: 'agentplatform.eflycloud.com',
    }
}

function getEntry(name: any) {
    if (environment['deployMode'] === 'ip') {
        let entryUrl = '//' + environment['host'] + ':' + MicroAppsPort[name] + '/';
        return entryUrl;
    } else{
        let platform:any = environment['platform'];
        let domain:any = MicroAppsDomain[platform];
        let entryUrl = '//' + domain[name]  + '/';
        return entryUrl;
    }
}


// VUE_APP_SUB_RESOURCE=//120.31.69.228:7777/subapp/resource/
// VUE_APP_SUB_USER=//120.31.69.228:7788/subapp/user/
// 应用访问入口路径
// let MicroAppsEntry: any = {
//     VUE_APP_SUB_RESOURCE: getEntry('VUE_APP_SUB_RESOURCE') + 'resource/',
//     VUE_APP_SUB_USER: getEntry('VUE_APP_SUB_USER') + 'user/'
// }

let MicroAppsEntry: any = {
    VUE_APP_SUB_RESOURCE: getEntry('VUE_APP_SUB_RESOURCE'),
    VUE_APP_SUB_USER: getEntry('VUE_APP_SUB_USER'),
    VUE_APP_SUB_PLATFORM: getEntry('VUE_APP_SUB_PLATFORM'),
}

let appsRouter: any = [
    {
        name: 'resource',
        entry: MicroAppsEntry.VUE_APP_SUB_RESOURCE,
        activeRule: '/manage/resource',
    },
    {
        name: 'user',
        entry: MicroAppsEntry.VUE_APP_SUB_USER,
        activeRule: '/manage/user',
    },
    {
        name: 'platform',
        entry: MicroAppsEntry.VUE_APP_SUB_PLATFORM,
        activeRule: '/manage/platform',
    },
]

let apps: any = appsRouter.map((item: any) => {
    return {
        ...item,
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            routerBase: item.activeRule, // 下发基础路由
            shared: shared,
            authority: authority,
            platform: 'ecp',
            loadingImg: loadingImg,
            window: window,
            openElasticByDay: Constant.openElasticByDay,    // 是否开放弹性计费资源（主机，磁盘，IP，RDS）
        }
    }
})

export const MicroApps = apps;
